<span class="hero-chars-counter">
  {{ control.value?.length || 0 }} / {{ maxNumberOfChars }}
</span>
